import React, { useEffect, useState } from 'react';
import { Dialog, Form, Input, Table } from 'tdesign-react';
import { SearchIcon } from 'tdesign-icons-react';
import useTable from '@/hooks/useTable';
import { isVoid } from '@/utils/common';

export default function Modal({ visible, handleClose, variables = [] }) {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const columns = [
    {
      colKey: 'row-select',
      type: 'multiple',
      fixed: 'left',
      width: 40,
    },
    {
      colKey: 'key',
      title: '变量key',
      width: 140,
    },
    {
      colKey: 'keyName',
      title: '变量名',
      width: 140,
    },
    {
      colKey: 'groupName',
      title: '变量组',
      width: 140,
    },
    {
      colKey: 'defaultValue',
      title: '默认值',
      width: 140,
    },
    {
      colKey: 'desc',
      title: '包含该变量节点',
      ellipsis: true,
      width: 160,
    },
  ];

  const keySearch = (value) => {
    if (isVoid(value)) {
      setData(variables);
    } else {
      const newData = variables.filter((item) => item.key.includes(value));
      setData(newData);
    }
  };

  const { config, setData, header } = useTable({
    columns,
    search: (
      <Form.FormItem>
        <Input placeholder='输入变量key检索' onChange={keySearch} suffixIcon={<SearchIcon />} />
      </Form.FormItem>
    ),
    searchButton: null,
  });

  useEffect(() => {
    if (visible) {
      setData(variables); // 剩余可选变量
    } else {
      setSelectedRowKeys([]);
    }
  }, [variables, setData, visible]);

  const onConfirm = () => {
    handleClose(selectedRowKeys);
  };

  return (
    <Dialog
      visible={visible}
      destroyOnClose
      width='70%'
      header='添加可选变量'
      placement='center'
      onClose={() => handleClose()}
      onConfirm={onConfirm}
    >
      {header}
      <Table
        {...config}
        rowKey='key'
        selectedRowKeys={selectedRowKeys}
        onSelectChange={setSelectedRowKeys}
        selectOnRowClick
      />
    </Dialog>
  );
}
